export default __webpack_public_path__ + "static/media/480_store01-es-mobile.40850a97.png";